import { Component, OnInit } from '@angular/core';
import { AlertService, AuthenticationService } from 'src/app/shared/_services';
import { SocialSharing } from '@ionic-native/social-sharing/ngx';
import { Clipboard } from '@ionic-native/clipboard/ngx';
import { Platform } from '@ionic/angular';
import { Router } from '@angular/router';
import { LoginStore } from 'src/app/shared/_services/store';

@Component({
  selector: 'app-refer',
  templateUrl: './refer.page.html',
  styleUrls: ['./refer.page.scss'],
  providers: [Clipboard]
})
export class ReferPage implements OnInit {
  subscription: any;
  referralCount = this.loginStore.getReferralCount();
  referralLink = this.loginStore.getReferralLink();

  constructor(
    private router: Router,
    private platform: Platform,
    private clipboard: Clipboard,
    private alertService: AlertService,
    private loginStore: LoginStore,
    private auth: AuthenticationService,
    private socialSharing: SocialSharing,
  ) { }

  copyLink() {
    const link = document.getElementById('link').textContent;
    this.clipboard.copy(link)
    .then(() => {
      this.alertService.standardToast('Copied!', 'bottom');
    })
    .catch(() => {
      this.alertService.standardToast('Unable to copy link. Please manually select and copy', 'bottom');
    });
  }

  shareLink() {
    const link = document.getElementById('link').textContent;
    // tslint:disable-next-line:max-line-length
    this.socialSharing.share('Earn up to ₦100,000 monthly by simply referring businesses to collect payments from customers using Bank3D. Download the App from Google Playstore or Apple Store and sign up using my link.', 'Download Bank3D Mobile App <br/>', null, link);
  }

  goBack() {
    this.router.navigateByUrl('/profile');
  }

  ionViewWillEnter() {
    document.title = 'Refer & Earn | Bank3D';
  }

  ionViewDidEnter() {
    this.subscription = this.platform.backButton.subscribeWithPriority(99999, () => {
      this.goBack();
    });
  }

  ionViewDidLeave() {
    this.subscription.unsubscribe();
  }

  ngOnInit() {
    document.title = 'Refer and Earn | Bank3D';
    if (this.auth.currentUserValue.role === 'merchant') {
      this.auth.getReferrals()
      .subscribe (
        (response: any) => {
          console.log(response);
          this.loginStore.setReferralCount(response.count);
          this.referralCount = this.loginStore.getReferralCount();
        },
        error => {
          console.log(error);
        }
      );
    }
  }

}
